import {createSlice, PayloadAction} from '@reduxjs/toolkit';

type ChangeTracker = {
  hasChange: boolean;
  modalTitle: string;
  modalDescription: string;
  okButtonLabel: string;
  closeButtonLabel: string;
  className?: string | undefined;
};

const initialChangeState: ChangeTracker = {
    hasChange: false,
    modalTitle: '',
    modalDescription: '',
    okButtonLabel: '',
    closeButtonLabel: '',
    className: undefined,
};

const initialState = {
  changeState: initialChangeState
};

const globalChangeTrackerSlice = createSlice({
  name: 'globalChangeTrackerSlice',
  initialState,
  reducers: {
    setChangeTracker(state, action: PayloadAction<ChangeTracker>) {
      state.changeState = {
        hasChange: action.payload.hasChange,
        modalTitle: action.payload.modalTitle,
        modalDescription: action.payload.modalDescription,
        okButtonLabel: action.payload.okButtonLabel,
        closeButtonLabel: action.payload.closeButtonLabel,
        className: action.payload.className,
      };
    },
    resetChangeTracker(state) {
      state.changeState = {
        hasChange: false,
        modalTitle: '',
        modalDescription: '',
        okButtonLabel: '',
        closeButtonLabel: '',
        className: undefined,
      };
    },
  },
});

export const {setChangeTracker, resetChangeTracker} =
  globalChangeTrackerSlice.actions;

export default globalChangeTrackerSlice.reducer;
